function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmlUserCheckedBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#D9E5F8",
    style: {
      fill: "#D9E5F8",
      fill: "color(display-p3 0.8494 0.8973 0.9718)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 20.75C16.83 20.75 14.25 18.17 14.25 15C14.25 11.83 16.83 9.25 20 9.25C23.17 9.25 25.75 11.83 25.75 15C25.75 18.17 23.17 20.75 20 20.75ZM20 10.75C17.66 10.75 15.75 12.66 15.75 15C15.75 17.34 17.66 19.25 20 19.25C22.34 19.25 24.25 17.34 24.25 15C24.25 12.66 22.34 10.75 20 10.75Z",
    fill: "#3F7CDB",
    style: {
      fill: "#3F7CDB",
      fill: "color(display-p3 0.2471 0.4863 0.8588)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4102 30.75C11.0002 30.75 10.6602 30.41 10.6602 30C10.6602 25.73 14.8502 22.25 20.0002 22.25C21.0102 22.25 22.0001 22.38 22.9601 22.65C23.3601 22.76 23.5902 23.17 23.4802 23.57C23.3702 23.97 22.9601 24.2 22.5602 24.09C21.7402 23.86 20.8802 23.75 20.0002 23.75C15.6802 23.75 12.1602 26.55 12.1602 30C12.1602 30.41 11.8202 30.75 11.4102 30.75Z",
    fill: "#3F7CDB",
    style: {
      fill: "#3F7CDB",
      fill: "color(display-p3 0.2471 0.4863 0.8588)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 30.75C24.34 30.75 22.78 29.87 21.94 28.44C21.49 27.72 21.25 26.87 21.25 26C21.25 24.54 21.9 23.19 23.03 22.29C23.87 21.62 24.93 21.25 26 21.25C28.62 21.25 30.75 23.38 30.75 26C30.75 26.87 30.51 27.72 30.06 28.45C29.81 28.87 29.49 29.25 29.11 29.57C28.28 30.33 27.17 30.75 26 30.75ZM26 22.75C25.26 22.75 24.56 23 23.97 23.47C23.2 24.08 22.75 25.01 22.75 26C22.75 26.59 22.91 27.17 23.22 27.67C23.8 28.65 24.87 29.25 26 29.25C26.79 29.25 27.55 28.96 28.13 28.44C28.39 28.22 28.61 27.96 28.77 27.68C29.09 27.17 29.25 26.59 29.25 26C29.25 24.21 27.79 22.75 26 22.75Z",
    fill: "#3F7CDB",
    style: {
      fill: "#3F7CDB",
      fill: "color(display-p3 0.2471 0.4863 0.8588)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4299 27.7396C25.2399 27.7396 25.0499 27.6696 24.8999 27.5196L23.9099 26.5296C23.6199 26.2396 23.6199 25.7595 23.9099 25.4695C24.1999 25.1795 24.6799 25.1795 24.9699 25.4695L25.4499 25.9496L27.0499 24.4695C27.3499 24.1895 27.8299 24.2096 28.1099 24.5096C28.3899 24.8096 28.3699 25.2896 28.0699 25.5696L25.9399 27.5396C25.7899 27.6696 25.6099 27.7396 25.4299 27.7396Z",
    fill: "#3F7CDB",
    style: {
      fill: "#3F7CDB",
      fill: "color(display-p3 0.2471 0.4863 0.8588)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmlUserCheckedBlue);
export default __webpack_public_path__ + "static/media/amlUserCheckedBlue.21c9ca355e1cf6077aa9166b7d413c65.svg";
export { ForwardRef as ReactComponent };